export const stats: { value: string; label: string }[] = [
  { value: '6', label: 'COMPLETE VOLUMES' },
  { value: '180+', label: 'DRILLS & GAMES' },
  { value: '48', label: 'TRAINING BLOCKS' },
  { value: '460+', label: 'PAGES OF CONTENT' },
]
